// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_CCs","cls2":"TranslationModal-cls2_YTk TranslationModal-cls1_CCs"};